import React from 'react'
import PunchOutHistory from "./punchouthistory";
import { RESOURCE } from '../../../const/resource';
import { useTranslation } from "react-i18next";

const OrderTotalFormat = (item: any) => {
    return (<td><span className="float-right">{`$${item.dataItem.orderTotal}`}</span></td>)
}

const PunchOutHistoryContainer = () => {
    const { t } = useTranslation();

    const columns = [
        {
            field: 'punchoutDate',
            title: t(RESOURCE.MyK_Label_SC_Puchout_Date),
            columnMenu: 'ColumnMenu',
            sortable: true,
            filterable: true,
            format: "{0: MM/dd/yyyy}",
            type: "date",
            filter: "date"
        },
        {
            field: "punchoutNumber",
            title: t(RESOURCE.MyK_Label_SC_Puchout) + " #",
            columnMenu: 'ColumnMenu',
            sortable: true,
            filterable: true,
            filter: "numeric"
        },
        {
            field: 'customerName',
            title: t(RESOURCE.MyK_Label_Customer_Name),
            sortable: true,
            filterable: true,
            columnMenu: 'ColumnMenu'
        },
        {
            field: 'distributorName',
            title: t(RESOURCE.MyK_Label_SC_Puchout_DistributorName),
            sortable: true,
            filterable: true,
            columnMenu: 'ColumnMenu'
        },
        {
            field: 'punchoutBy',
            title: t(RESOURCE.MyK_Label_SC_Puchout_By),
            sortable: true,
            filterable: true,
            columnMenu: 'ColumnMenu'
        },
        {
            field: 'noofItems',
            title: "# " + t(RESOURCE.MyK_Label_SC_Puchout_Of_Items),
            sortable: true,
            filterable: true,
            filter: "numeric",
            columnMenu: 'ColumnMenu'
        },
        {
            field: 'orderTotal',
            title: t(RESOURCE.MyK_Label_ShoppingCart_Total),
            sortable: true,
            filterable: true,
            columnMenu: 'ColumnMenu',
            filter: "numeric",
            cell: (row: any) => OrderTotalFormat(row)
        },
    ]

    return (
       <PunchOutHistory columns={columns} />
    )
}

export default PunchOutHistoryContainer